import { useCallback } from "react";
import { useNeedHelp } from "modules/helpChat";
import { useI18n } from "i18n";
import { Tooltip } from "@remo-co/ui-core/src/components/Tooltip";
import { Button } from "@remo-co/ui-core/src/components/Button";
import { useSelector } from "react-redux";
import {
  selectDisableFreshchatWidget,
  selectEnableAgencyWhiteLabelling,
} from "modules/settings/redux/selectors";
import { SupportIcon } from "@remo-co/ui-core/src/icons/Support";
import { useStyles } from "./styles";

export const ContactSupport = () => {
  const enableAgencyWhiteLabelling = useSelector(
    selectEnableAgencyWhiteLabelling,
  );
  const disableFreshchatWidget = useSelector(selectDisableFreshchatWidget);
  const { callApi } = useNeedHelp();
  const { t } = useI18n(["common"]);
  const styles = useStyles();

  const openSupport = useCallback(() => callApi("showNewMessage"), [callApi]);

  if (enableAgencyWhiteLabelling && disableFreshchatWidget) {
    return null;
  }

  return (
    <Tooltip title={t("common:contact.support")} placement="left">
      <Button
        isIconButton
        variant="ghost"
        data-testid="contact-support-button"
        className={styles.supportButton}
        onClick={openSupport}
      >
        <SupportIcon />
      </Button>
    </Tooltip>
  );
};
